export class DetalleBoletaHonorarios {
   detalleBoletaHonorarioId: string;
   boletaHonorarioId: string;
   descripcion: string;
   valor: number;
}
